import { SubscriptionsContext } from "@/context/SubscriptionsContext";
import React from "react";

export default function useSubscriptions() {
  return React.useContext(SubscriptionsContext);
}
